<div class="card flex justify-content-center">
    <button mat-icon-button (click)="visible = !visible" [matBadge]="getUnreadSum() > 0 ? getUnreadSum() : ''" [matTooltip]="'chat' | translate">
        <mat-icon svgIcon="messages"></mat-icon>
    </button>
    <p-dialog
    [keepInViewport]="false"
    [(visible)]="visible"
    [header]="'chat' | translate"
    class="dialog-window"
    [resizable]="true"
    [maximizable]="true"
    position="right"
    [style]="{width: '500px'}"
    [autoZIndex]="false"
    >
        <p-header>
            <img src="./../../favicon.ico">
        </p-header>
        <app-chat-window></app-chat-window>
    </p-dialog>
</div>